import { EventMarker } from '@hotjar/webapp/features/Playbacks/types';

export const findClosestItemIndex = (currentTime: number, eventMarkers: EventMarker[]) => {
  let previousItemTime = -1;
  const lastIndex = eventMarkers.length - 1;
  // I need to have access to the index and be able to break the loop
  // eslint-disable-next-line no-plusplus
  for (let i = 0; i < eventMarkers.length; i++) {
    const item = eventMarkers[i];
    if (i === 0 && item.time > currentTime) {
      return i;
    }
    if (i === lastIndex) {
      return lastIndex;
    }
    if (previousItemTime <= currentTime && item.time >= currentTime) {
      return Math.max(i - 1, 0);
    }
    previousItemTime = item.time;
  }
  return 0;
};
